module.exports = __webpack_public_path__ + "img/text-stimuli-symbol.996bdccb.svg";